/* The Added to cart popup (Showcase's #added-to-cart, built in assets/theme.js; we only add nodes and restyle it).
   After a piece is added on its product page this adds two things to the popup, and nothing else:
   1. One quiet line right under the piece (p.cl-popup-quiet), from /cart.js after the add:
      - US visitors paying in USD (window.__clShip, snippets/cl-ship-line 'config'): "Free US shipping on this order",
        or "$11 from free US shipping", from CozyleighPairs.shipRate, the same rules as the cart. Nothing for a Desk
        Shelf or a cart where nothing ships.
      - Everywhere else we ship (window.__clIntl, snippets/cl-intl-ship 'config'): "Shipping to Canada $27.40 · import
        taxes may be due on delivery", but only a rate Shopify's own /cart/shipping_rates.json returned for this cart and
        a sample address in the country (the same logic as assets/cozyleigh-intl-ship.js). We never work out a number;
        on any error or an empty answer the line stays hidden.
      It repaints after an Add here.
   2. "Goes with it", under the Check out / View cart buttons so the way to pay is never pushed off a phone screen:
      one suggestion on phones, two on wider screens, in the same colour (or colour family) when available, each with one
      short line saying why it belongs (CozyleighPairs.reason). On the first card the line is "Add one and this order
      ships free" when that is true by the same maths as the cart's add-on card (snippets/cl-cart-addon: US, USD, under
      the line, and this variant takes the order to or over the line for its class); never otherwise. What goes with what
      comes from assets/cozyleigh-pairs.js and what shoppers buy together:
   - stand -> Fa tray, Pro desk mat, puck (the small, easy yes first; the mat is the base the stand snaps onto; every
     stand already includes a puck, so its line says "A second one" and it reads as a spare, not a missing part)
   - puck -> Fa tray, stand, mat; mat -> stand, Fa tray, puck
   - Fa tray -> another Fa tray in a colour not in the cart yet ("Stack another"), then stand, mat, puck
   - wooden pieces -> each other (Zen Tray + Book Stand, Desk Shelf + Zen Tray) and the Fa tray
   - keycaps -> the novelty kit (and artisan) of the same profile
   - Imperfectly Perfect pieces -> the Imperfectly Perfect version of each companion where there is one
   Pieces that come in sizes (the mat, the wood) show size chips, starting on the first size in stock, so nobody gets
   a size they didn't see; colour, wood and Pro are already matched. A Fa tray is shown with its lid on
   (CozyleighPairs.offerImage).
   Nothing already in the cart (in either version), nothing sold out, and no stand or mat to a signed-in customer who
   already bought one (window.__clOwned, from sections/main-product). Adds carry the hidden line properties
   _source=added_popup and _rule (which rule picked it) so Shopify orders show whether these sell; GA4 gets the list
   being shown and each Add through window.clAnalytics.recommendation (assets/cozyleigh-analytics.js).
   Styles: assets/cozyleigh-kit.css (.cl-popup-quiet, .cl-pairs). */
(function () {
  if (window.__clAddedPairs) return;
  window.__clAddedPairs = true;

  var COMPANIONS = {
    stand: ['fa', 'mat', 'puck'],
    puck: ['fa', 'stand', 'mat'],
    fa: ['stack', 'stand', 'mat', 'puck'],
    mat: ['stand', 'fa', 'puck']
  };
  // two on wider screens, one on phones so Check out and the suggestion fit on one screen; read when the popup is built, so a
  // rotated or resized window is judged as it is now, not as it was at page load
  function maxOffers() { return window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 1 : 2; }
  // pieces people buy once: not suggested again to someone who already owns one (stands and pucks get gifted and
  // bought in twos, Fa trays stack, so those stay)
  var ONCE = ['stand', 'mat'];

  function money(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(src, w) {
    if (!src) return '';
    src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function getJSON(url) { return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

  // Showcase builds a new #added-to-cart on every add and leaves the old, hidden ones in the page, so we always work on
  // the last one. Each add gets a stamp; a popup that already carries our nodes from an earlier add is skipped, so a
  // second add on the same page never paints into the hidden first popup. No stamp = repaint whatever is showing now.
  var addSeq = 0;
  function lastInner() { var l = document.querySelectorAll('#added-to-cart .inner'); return l.length ? l[l.length - 1] : null; }
  function popupFor(stamp) {
    var inner = lastInner();
    if (!inner) return null;
    if (stamp == null) return inner;
    var mark = inner.getAttribute('data-cl-add');
    if (mark === String(stamp)) return inner;
    if (mark && inner.querySelector('[data-cl-popup-quiet], .cl-pairs')) return null;   // still the old popup
    inner.setAttribute('data-cl-add', String(stamp));
    return inner;
  }
  function waitForPopup(cb, stamp) {
    var found = popupFor(stamp);
    if (found) return cb(found);
    var mo = new MutationObserver(function () {
      var el = popupFor(stamp);
      if (el) { mo.disconnect(); cb(el); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 3000);
  }

  // Check out is the primary action: move the existing link (not a clone) first, so keyboard and screen-reader order match
  // what the eye sees and Showcase keeps its own navigation hooks. The setting that offers only View cart is left alone.
  function arrangeActions(inner) {
    var links = inner.querySelector('.links');
    if (!links || links.classList.contains('links--no-checkout')) return;
    var checkout = links.querySelector('.button--checkout');
    if (checkout && links.firstElementChild !== checkout) links.insertBefore(checkout, links.firstChild);
  }

  function refreshCartCount() {
    getJSON('/cart.js').then(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll('#site-control a.cart'), function (a) {
        var n = a.querySelector(':scope > div'); if (n) n.textContent = c.item_count;
        a.classList.toggle('is-empty', !c.item_count);
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
    }).catch(function () {});
  }

  // whole dollars when the cents are round, else two decimals (as assets/cozyleigh-ship-line.js)
  function usd(cents) {
    var whole = cents % 100 === 0;
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100); }
    catch (e) { return '$' + (whole ? cents / 100 : (cents / 100).toFixed(2)); }
  }
  function strong(text) { var b = document.createElement('b'); b.textContent = text; return b; }

  // the cart's free-shipping state, or null (off, nothing ships, or a Desk Shelf). Product tags aren't in cart.js, so
  // pieces are classed by handle and name (CozyleighPairs.shipClass), which covers every piece we sell. The rates only
  // decide the price, not shown here; any non-zero amounts keep "free" meaning over the line.
  function shipStateOf(cart) {
    var P = window.CozyleighPairs, cfg = window.__clShip;
    if (!P || !P.shipRate || !cfg || !cart || !cart.items) return null;
    if (cart.currency && cart.currency !== 'USD') return null;
    return P.shipRate(P.shipItems(cart.items, {}), cfg.lines, { box: 1, other: 1, tray: 1, pro: 1 });
  }

  // would adding this variant take the cart over its line? The same maths as shipsFree() in snippets/cl-cart-addon.
  // Only for US carts in USD that are under the line now; a piece that ships on its own (osume, Gantri, MySweetChubs,
  // digital) never counts toward the line.
  function shipsFreeWith(cart, p, v) {
    var P = window.CozyleighPairs, cfg = window.__clShip;
    if (!P || !P.shipClass || !cfg || !cart || !cart.items || !p || !v || v.price == null) return false;
    if (cart.currency && cart.currency !== 'USD') return false;
    var rows = P.shipItems(cart.items, {}).filter(function (r) { return r.cls !== 'none'; });
    var classes = rows.map(function (r) { return r.cls; });
    var subtotal = rows.reduce(function (n, r) { return n + (+r.cents || 0); }, 0);
    var line = P.freeShipLine(classes, cfg.lines);
    if (!line || subtotal >= line) return false;   // nothing ships, a Desk Shelf, or the order ships free already
    var cls = P.shipClass(p.handle, p.title, p.tags, v.requires_shipping, p.vendor);
    if (cls === 'none') return false;
    line = P.freeShipLine(classes.concat([cls]), cfg.lines);
    return !!line && subtotal + Number(v.price) >= line;
  }

  // Outside the US: the cheapest rate Shopify itself returns for this cart and a sample address in the country
  // (assets/cozyleigh-intl-ship.js does the same on the cart page). One request in flight; a newer cart asks again after.
  var intl = { busy: false, again: null };
  function intlMoney(amount, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount); }
    catch (e) { return null; }
  }
  function quietNode(inner) {
    var node = inner.querySelector('[data-cl-popup-quiet]');
    if (!node) {
      node = document.createElement('p'); node.className = 'cl-popup-quiet'; node.setAttribute('data-cl-popup-quiet', '');
      node.setAttribute('role', 'status'); node.setAttribute('aria-live', 'polite'); node.hidden = true;
      var item = inner.querySelector('.cart-product'), links = inner.querySelector('.links');
      if (item) item.insertAdjacentElement('afterend', node);
      else if (links) inner.insertBefore(node, links);
      else inner.appendChild(node);
    }
    return node;
  }
  function paintIntl(inner, cart) {
    var P = window.CozyleighPairs, cfg = window.__clIntl, node = quietNode(inner);
    node.hidden = true; node.textContent = '';
    var ships = P && P.shipItems && cart && cart.items && P.shipItems(cart.items, {}).some(function (r) { return r.cls !== 'none'; });
    if (!cfg || !cfg.name || !ships) return;
    if (intl.busy) { intl.again = { inner: inner, cart: cart }; return; }
    intl.busy = true;
    var qs = '?shipping_address[country]=' + encodeURIComponent(cfg.name) + '&shipping_address[province]=' + encodeURIComponent(cfg.province || '') +
      '&shipping_address[zip]=' + encodeURIComponent(cfg.zip || '');
    fetch('/cart/shipping_rates.json' + qs, { headers: { Accept: 'application/json' } })
      .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (data) {
        var rates = ((data && data.shipping_rates) || []).map(function (r) { return { amount: parseFloat(r.price), currency: r.currency }; })
          .filter(function (r) { return isFinite(r.amount) && r.amount >= 0 && r.currency; });
        if (!rates.length || intl.again) return;   // nothing to say, or the cart changed while we asked (the next answer is the one to show)
        var cheapest = rates.reduce(function (best, r) { return !best || r.amount < best.amount ? r : best; }, null);
        var text = intlMoney(cheapest.amount, cheapest.currency);
        var n = inner.isConnected && inner.querySelector('[data-cl-popup-quiet]') || (lastInner() || document).querySelector('[data-cl-popup-quiet]');   // the popup may have been rebuilt while we waited
        if (!text || !n) return;
        n.textContent = '';
        n.appendChild(document.createTextNode('Shipping to ' + cfg.name + (rates.length > 1 ? ' from ' : ' ')));
        n.appendChild(strong(text));
        n.appendChild(document.createTextNode(' · import taxes may be due on delivery'));
        n.hidden = false;
      })
      .catch(function () {})
      .then(function () {
        intl.busy = false;
        var next = intl.again; intl.again = null;
        if (next) paintIntl(next.inner.isConnected ? next.inner : (lastInner() || next.inner), next.cart);
      });
  }

  // The one quiet line under the piece: where this cart stands against free US shipping, or what Shopify says shipping
  // costs to the shopper's country. Hidden when there is nothing true to say.
  function paintQuiet(inner, cart) {
    if (window.__clShip) {
      var r = shipStateOf(cart), node = quietNode(inner);
      node.textContent = '';
      if (!r) { node.hidden = true; return; }
      if (r.free) node.appendChild(document.createTextNode('Free US shipping on this order'));
      else { node.appendChild(strong(usd(r.line - r.subtotal))); node.appendChild(document.createTextNode(' from free US shipping')); }
      node.hidden = false;
    } else if (window.__clIntl) {
      paintIntl(inner, cart);
    }
  }
  function shipAfterAdd(stamp) {
    if (!window.__clShip && !window.__clIntl) return;
    getJSON('/cart.js').then(function (c) {
      waitForPopup(function (inner) { paintQuiet(inner, c); }, stamp);
    }).catch(function () {});
  }

  function track(action, offers) {
    if (!window.clAnalytics || !window.clAnalytics.recommendation) return;
    window.clAnalytics.recommendation(action, 'added_popup', offers.map(function (o) {
      return { product_id: o.product.id, variant_id: o.variant.id, product_handle: o.product.handle, rule: o.rule, position: o.position };
    }));
  }

  // the variant with these option values, or null
  function variantWith(p, values) {
    return (p.variants || []).filter(function (v) {
      var ov = window.CozyleighPairs.optionValues(v);
      return values.every(function (x, i) { return ov[i] === x; });
    })[0] || null;
  }
  // size chips for a piece that comes in sizes: the other options (colour, wood, Pro) stay as matched
  function sizeChips(o, onPick) {
    if (o.sizeAt < 0) return null;
    var wrap = document.createElement('div'); wrap.className = 'cl-pair__sizes';
    wrap.setAttribute('role', 'radiogroup'); wrap.setAttribute('aria-label', 'Size for ' + o.product.title);
    var values = (o.product.options[o.sizeAt].values || []).map(String);
    values.forEach(function (value) {
      var c = document.createElement('button'); c.type = 'button'; c.className = 'cl-pair__size';
      c.setAttribute('role', 'radio'); c.setAttribute('data-value', value); c.title = value;
      c.textContent = window.CozyleighPairs.shortSize(value);
      c.addEventListener('click', function () {
        if (c.disabled) return;
        var want = window.CozyleighPairs.optionValues(o.variant).slice(); want[o.sizeAt] = value;
        var v = variantWith(o.product, want);
        if (!v || !v.available) return;
        o.variant = v; paintSizes(wrap, o); onPick();
      });
      wrap.appendChild(c);
    });
    paintSizes(wrap, o);
    return wrap;
  }
  function paintSizes(wrap, o) {
    var cur = window.CozyleighPairs.optionValues(o.variant);
    Array.prototype.forEach.call(wrap.children, function (c) {
      var want = cur.slice(); want[o.sizeAt] = c.getAttribute('data-value');
      var v = variantWith(o.product, want), on = cur[o.sizeAt] === c.getAttribute('data-value');
      c.disabled = !v || !v.available;
      c.classList.toggle('is-on', on); c.setAttribute('aria-checked', String(on));
      c.textContent = window.CozyleighPairs.shortSize(c.getAttribute('data-value')) + (c.disabled ? ' · sold out' : '');
    });
  }

  function render(inner, offers) {
    if (!offers.length || inner.querySelector('.cl-pairs')) return;
    offers.forEach(function (o, i) { o.position = i + 1; });
    var box = document.createElement('div'); box.className = 'cl-pairs';
    var title = document.createElement('p'); title.className = 'cl-pairs__title'; title.textContent = 'Goes with it';
    var ul = document.createElement('ul'); ul.className = 'cl-pairs__list';
    var repaints = [];
    offers.forEach(function (o) {
      var li = document.createElement('li'); li.className = 'cl-pair';
      var link = document.createElement('a'); link.className = 'cl-pair__link'; link.href = o.product.url + '?variant=' + o.variant.id;
      link.setAttribute('data-cl-placement', 'added_popup_card_' + o.position);
      var img = window.CozyleighPairs.offerImage(o.product, o.variant);
      if (img) { var im = document.createElement('img'); im.src = sized(img, 128); im.alt = ''; im.width = 64; im.height = 64; link.appendChild(im); }
      var text = document.createElement('span'); text.className = 'cl-pair__text';
      var name = document.createElement('span'); name.className = 'cl-pair__name'; name.textContent = o.product.title;
      text.appendChild(name);
      var why = document.createElement('span'); why.className = 'cl-pair__why'; text.appendChild(why);
      var meta = document.createElement('span'); meta.className = 'cl-pair__meta';
      text.appendChild(meta); link.appendChild(text); li.appendChild(link);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cl-pair__add'; b.textContent = 'Add';
      var sizes = sizeChips(o, function () { paintChoice(); });
      // the line under the name, the photo and the button follow the size picked
      function paintChoice() {
        // the first card says "ships free" only when this variant really takes the order over the line (and re-checks as the size changes)
        var line = o.why;
        if (o.position === 1 && shipsFreeWith(o.cart, o.product, o.variant)) line = 'Add one and this order ships free';
        if (o.added) line = '';   // no pitch next to "Added ✓"
        why.textContent = line || ''; why.hidden = !line;
        var opts = window.CozyleighPairs.optionValues(o.variant).filter(function (v, i) { return v !== 'Default Title' && i !== o.sizeAt; });
        meta.textContent = (o.stack ? 'Stack another · ' : '') + (opts.length ? opts.join(' · ') + ' · ' : '') + money(o.variant.price);
        b.setAttribute('aria-label', 'Add ' + o.product.title + (o.variant.title && o.variant.title !== 'Default Title' ? ' in ' + o.variant.title : '') + ' to cart');
        link.href = o.product.url + '?variant=' + o.variant.id;
        var src = window.CozyleighPairs.offerImage(o.product, o.variant);
        var im = link.querySelector('img'); if (im && src) im.src = sized(src, 128);
      }
      paintChoice(); repaints.push(paintChoice);
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.disabled = true; b.textContent = 'Adding…';
        if (sizes) Array.prototype.forEach.call(sizes.querySelectorAll('button'), function (c) { c.disabled = true; });
        track('add', [o]);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: o.variant.id, quantity: 1, properties: { _source: 'added_popup', _rule: o.rule } }] })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          b.textContent = 'Added ✓'; b.classList.add('is-added'); o.added = true;
          refreshCartCount();
          shipAfterAdd();
          // the other cards' "ships free" line follows the cart as it is now
          getJSON('/cart.js').then(function (c) { offers.forEach(function (x) { x.cart = c; }); repaints.forEach(function (f) { f(); }); }).catch(function () { repaints.forEach(function (f) { f(); }); });
        }).catch(function () {
          b.disabled = false; b.textContent = 'Try again';
          if (sizes) paintSizes(sizes, o);
        });
      });
      li.appendChild(b);
      if (sizes) li.appendChild(sizes);
      ul.appendChild(li);
    });
    box.appendChild(title); box.appendChild(ul);
    // under the View cart / Check out buttons, so the way to pay is never pushed off a phone screen
    var links = inner.querySelector('.links');
    inner.insertBefore(box, links ? links.nextSibling : null);
    track('shown', offers);
  }

  // the piece keys ('stand', 'mat', ...) a signed-in customer has bought before (sections/main-product)
  function ownedKeys() {
    var P = window.CozyleighPairs;
    return (window.__clOwned || []).map(function (h) { var pc = P.pieceOf(h); return pc && pc.key; }).filter(Boolean);
  }

  // what to look for after this piece: [{handle, stack, rule, what}] in order of preference
  function wantedFor(handle) {
    var P = window.CozyleighPairs;
    if (P.KEYCAPS[handle]) return P.KEYCAPS[handle].map(function (h) { return { handle: h, rule: 'keycap_kit', what: '' }; });
    var piece = P.pieceOf(handle);
    var keys = piece ? COMPANIONS[piece.key] : P.WOOD_PAIRS[handle] || null;
    if (!keys) return [];
    var owned = ownedKeys();
    return keys.filter(function (k) { return !(ONCE.indexOf(k) > -1 && owned.indexOf(k) > -1); }).map(function (k) {
      if (k === 'stack') return { handle: handle, stack: true, rule: 'stack_another', what: 'stack' };
      // another wooden piece
      if (!P.PIECES[k]) return { handle: k, rule: 'companion', what: k };
      var h = P.handleFor(k, piece && piece.ip);
      return { handle: h, rule: P.pieceOf(h).ip ? 'imperfectly_perfect' : 'companion', what: k };
    });
  }

  function offerFor(added, stamp) {
    var P = window.CozyleighPairs;
    if (!P) return;
    var wanted = wantedFor(added.handle);
    if (!wanted.length) return;
    var colours = (added.variant_options || []).map(String);
    Promise.all([getJSON('/cart.js')].concat(wanted.map(function (w) { return getJSON('/products/' + w.handle + '.js').catch(function () { return null; }); })))
      .then(function (res) {
        var items = res[0].items || [];
        var inCart = items.map(function (i) { return i.product_id; });
        // a piece in the cart in either version (full price or Imperfectly Perfect) counts as there already
        var piecesInCart = items.map(function (i) { var pc = P.pieceOf(i.handle); return pc && pc.key; }).filter(Boolean);
        var addedPiece = P.pieceOf(added.handle);
        // the reason lines speak to the stand when there is one: just added, in the cart, or already theirs
        var ctx = { stand: (addedPiece && addedPiece.key === 'stand') || piecesInCart.indexOf('stand') > -1 || ownedKeys().indexOf('stand') > -1 };
        var offers = [];
        res.slice(1).forEach(function (p, i) {
          if (!p || !p.available || offers.length >= maxOffers()) return;
          var variant;
          if (wanted[i].stack) {
            // another of the same tray, in a colour the cart doesn't have yet
            var have = items.filter(function (it) { return it.product_id === p.id; }).map(function (it) { return String((it.variant_options || [])[0]); });
            variant = (p.variants || []).filter(function (v) { return v.available && have.indexOf(String(v.option1)) < 0; })[0];
          } else {
            var pc = P.pieceOf(p.handle);
            if (inCart.indexOf(p.id) > -1 || (pc && piecesInCart.indexOf(pc.key) > -1)) return;
            variant = P.bestVariant(p.variants, colours);
          }
          if (variant) offers.push({ product: p, variant: variant, stack: !!wanted[i].stack, rule: wanted[i].rule, why: P.reason(wanted[i].what, ctx), sizeAt: P.sizeIndex(p), cart: res[0] });
        });
        if (offers.length) waitForPopup(function (inner) { render(inner, offers); }, stamp);
      }).catch(function () {});
  }

  function hook() {
    var $ = (window.theme && window.theme.jQuery) || window.jQuery;
    if (!$) return false;
    $(document).on('ajaxSuccess', function (ev, xhr, settings) {
      if (!settings || !/\/cart\/add/.test(settings.url || '')) return;
      var added = null;
      try { added = JSON.parse(xhr.responseText); } catch (e) {}
      if (added && added.items && added.items.length) added = added.items[0];
      var stamp = ++addSeq;
      waitForPopup(arrangeActions, stamp);   // runs even when this piece has no companions or shipping line
      if (added && added.handle) offerFor(added, stamp);
      shipAfterAdd(stamp);
    });
    return true;
  }
  if (!hook()) document.addEventListener('DOMContentLoaded', hook);
})();
